/**
 * Shared raw host-tag allowlists for the DOM/WebView runtime escape hatch.
 * Keep these constants aligned with the DOM node factory so JSX typing and
 * renderer capabilities stay in sync.
 */
export const UI_HTML_HOST_TAGS = [
    'a',
    'article',
    'aside',
    'br',
    'button',
    'code',
    'div',
    'em',
    'fieldset',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'header',
    'hr',
    'img',
    'input',
    'label',
    'legend',
    'li',
    'main',
    'nav',
    'ol',
    'option',
    'p',
    'pre',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'textarea',
    'ul',
    'video',
];
export const UI_SVG_HOST_TAGS = [
    'svg',
    'path',
    'g',
    'circle',
    'rect',
    'line',
    'polyline',
    'polygon',
    'ellipse',
    'defs',
    'symbol',
    'use',
    'clipPath',
    'clippath',
    'mask',
    'linearGradient',
    'lineargradient',
    'pattern',
    'radialGradient',
    'radialgradient',
    'stop',
    'title',
    'desc',
    'text',
    'tspan',
];
export const UI_HOST_TAGS = [
    ...UI_HTML_HOST_TAGS,
    ...UI_SVG_HOST_TAGS,
];
//# sourceMappingURL=host-tags.js.map